/*
These functions make sure WordPress
and Foundation play nice together.
*/



jQuery(document).ready(function ($) {


	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
});


window.addEventListener('load', function () {
	if (jQuery('.bh-gallery--carousel').length) {
		new Glider(document.querySelector('.bh-gallery--carousel'), {
			slidesToShow: 2,
			arrows: {
				prev: '.glider-prev',
				next: '.glider-next'
			},
			draggable: true,
			responsive: [{
				// screens greater than >= 775px
				breakpoint: 640,
				settings: {
					slidesToShow: 3,
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				}
			}, {
				breakpoint: 1400,
				settings: {
					slidesToShow: 5,
				}
			}]

		});
	}
});


(function($) {
	$(function() {
		$('.quantity-stepper').on('click', function() {
			let v = parseInt($(this).parent().find('input.qty').val());
			if(!v)
				v = 1;
			else
				v = v + parseInt($(this).data('step'));
			$(this).parent().find('input.qty').val(v)
		})
		$('.product-category-menu-bar button, .product-category-menu-bar .menu-header').on('click', function(event) {
			event.stopPropagation(); // Cancel event bubbling
			$($(this).data('target')).each(function () {
				let menu = $(this).get(0);
				menu.style.maxHeight = menu.style.maxHeight ? null : menu.scrollHeight + 'px';
			})
			return false;
		});
	});
})(jQuery);
